import React from 'react';
import PropTypes from 'prop-types';

import { FlexBox } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import LabeledCheckBox from '@ecp/common/src/components/checkbox/LabeledCheckBox';

const CheckboxGroupUnstyled = (props) => {
  const {
    itemList,
    rootComponent: RootComponent,
    itemComponent: Item,
    spacing,
    rootProps,
    itemProps,
    onChange,
    flexBasis,
    ...checkboxProps
  } = props;

  const handleChange = (e, index, item) => {
    e.stopPropagation();
    const checked = e.target.checked;
    onChange(index, { ...item, checked }, e);
  };

  return (
    <RootComponent {...rootProps}>
      {flexBasis ? (
        <FlexBox width={'100%'} justify-content={'space-between'} flex-wrap={'wrap'}>
          {itemList.map((item, index) => (
            <FlexBox flex-basis={flexBasis} key={index}>
              <React.Fragment key={`checkbox-group__${index}`}>
                {spacing && index !== 0 && <Spacing left={spacing} top={spacing} />}
                <Item
                  {...checkboxProps}
                  onChange={(e) => handleChange(e, index, item)}
                  rootProps={itemProps}
                  {...item}
                />
              </React.Fragment>
            </FlexBox>
          ))}
        </FlexBox>
      ) : (
        <>
          {itemList.map((item, index) => (
            <React.Fragment key={`checkbox-group__${index}`}>
              {spacing && index !== 0 && <Spacing left={spacing} top={spacing} />}
              <Item {...checkboxProps} onChange={(e) => handleChange(e, index, item)} rootProps={itemProps} {...item} />
            </React.Fragment>
          ))}
        </>
      )}
    </RootComponent>
  );
};

CheckboxGroupUnstyled.propTypes = {
  rootComponent: PropTypes.oneOfType([PropTypes.elementType, PropTypes.element]),
  itemComponent: PropTypes.oneOfType([PropTypes.elementType, PropTypes.element]),
  itemList: PropTypes.array.isRequired,
  rootProps: PropTypes.object,
  spacing: PropTypes.string,
  itemProps: PropTypes.object,
  onChange: PropTypes.func,
  flexBasis: PropTypes.string,
};

CheckboxGroupUnstyled.defaultProps = {
  rootComponent: FlexBox,
  itemComponent: LabeledCheckBox,
  itemList: [],
  rootProps: {},
};

export default CheckboxGroupUnstyled;
